// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"46":"b2a69b7b","485":"48509d79"}[chunkId] + ".js";
};